module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/24609c50afb138ad00a7027f23265783.png";